<template>
  <div class="flex items-center gap-1">
    <p :class="aeroplaneClasses" style="height: 30px; width: 30px; text-shadow: 1px 1px 3px #999"
      title="Aeroplane">{{ aeroplaneValue }}</p>
    <p :class="helicopterClasses" style="height: 30px; width: 30px; text-shadow: 1px 1px 3px #999"
      title="Helicopter">{{ helicopterValue }}</p>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

const YES = "shadow text-center px-2 bg-gradient-to-br from-green-300 to-green-400 rounded-full text-white flex items-center text-sm";
const NO = "shadow text-center px-2 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full text-gray-500 flex items-center text-sm";

export default defineComponent({
  name: "DualTickValue",
  computed: {
    aeroplane() {
      return !!this.params.value?.aeroplane;
    },
    helicopter() {
      return !!this.params.value?.helicopter;
    },
    aeroplaneValue() {
      return this.aeroplane ? "✓" : "–";
    },
    helicopterValue() {
      return this.helicopter ? "✓" : "–";
    },
    aeroplaneClasses() {
      return this.aeroplane ? YES : NO;
    },
    helicopterClasses() {
      return this.helicopter ? YES : NO;
    },
  },
});
</script>
